import { getRequest, postRequest } from '@/api/request';

export const listTemplates = () => getRequest({
  url: '/jobprofile/approval-templates/list-templates?includeArchived=true',
});

export const getTemplate = (ulid) => getRequest({
  url: `/jobprofile/approval-templates/get-template?ulid=${encodeURIComponent(ulid)}`,
});

export const createTemplate = (payload) => postRequest({
  url: '/jobprofile/approval-templates/create-template',
  body: payload,
});

export const updateTemplate = (ulid, payload) => postRequest({
  url: `/jobprofile/approval-templates/update-template?ulid=${encodeURIComponent(ulid)}`,
  body: payload,
});

export const deleteTemplate = (ulid) => postRequest({
  url: `/jobprofile/approval-templates/delete-template?ulid=${encodeURIComponent(ulid)}`,
});
